export const calculateQuizValues = data => {
  const incomeValue = Number(data.incomeValue) + Number(data.secondIncomeValue);
  const carPaymentValue = Number(data.carPaymentValue) + Number(data.secondCarPaymentValue);
  const studentPaymentValue = Number(data.studentPaymentValue) + Number(data.secondStudentPaymentValue);
  const cardPaymentValue = Number(data.cardPaymentValue) + Number(data.secondCardPaymentValue);
  const otherPaymentValue = Number(data.otherPaymentValue) + Number(data.secondOtherPaymentValue);
  const savingsValue = Number(data.savingsValue) + Number(data.secondSavingsValue);
  const equityValue = Number(data.currentHouseValue) * 0.94 - Number(data.currentHouseMortgageBal);

  const perDollarPandI5 =
    ((Number(data.interestRate) / 12) * (1 - Number(0.05))) /
    (1 - (1 + Number(data.interestRate) / 12) ** (Number(data.mortgageTerm) * -12));

  const perDollarPandI10 =
    ((Number(data.interestRate) / 12) * (1 - Number(0.1))) /
    (1 - (1 + Number(data.interestRate) / 12) ** (Number(data.mortgageTerm) * -12));

  const perDollarPandI15 =
    ((Number(data.interestRate) / 12) * (1 - Number(0.15))) /
    (1 - (1 + Number(data.interestRate) / 12) ** (Number(data.mortgageTerm) * -12));

  const perDollarPandI20 =
    ((Number(data.interestRate) / 12) * (1 - Number(0.2))) /
    (1 - (1 + Number(data.interestRate) / 12) ** (Number(data.mortgageTerm) * -12));

  const perDollarMortgageInsurance5 = (Number(0.0078) * (1 - Number(0.05))) / 12;
  const perDollarMortgageInsurance10 = (Number(0.0055) * (1 - Number(0.1))) / 12;
  const perDollarMortgageInsurance15 = (Number(0.0025) * (1 - Number(0.15))) / 12;
  const perDollarMortgageInsurance20 = Number(0);
  const perDollarTaxesAndInsurance = (Number(data.propertyTaxRate) + 0.004) / 12;

  /* these const use other const */

  const monthlyIncome = incomeValue / Number(12);
  const savingsCushion = (incomeValue / Number(12)) * Number(data.monthsCushion);
  const totalDebtPayments = carPaymentValue + studentPaymentValue + cardPaymentValue + otherPaymentValue;
  const availForHouse = savingsValue + equityValue - savingsCushion;

  const availForHouseMax5 = Math.min(
    537263,
    (availForHouse - 1200) / (0.05 + (0.017 * 0.5 + 0.95 * 0.0078 * 0.5 + 0.008)),
  );

  const availForHouseMaxDp5 = availForHouseMax5 * 0.05;
  const availForHouseMaxCc5 = 1200 + availForHouseMax5 * (0.017 * 0.5 + 0.95 * 0.0078 * 0.5 + 0.008);

  const availForMaxPayment5 =
    availForHouseMax5 * (perDollarPandI5 + perDollarTaxesAndInsurance + perDollarMortgageInsurance5);

  const availForHouseMax10 = (availForHouse - 1200) / (0.1 + (0.017 * 0.5 + 0.95 * 0.0078 * 0.5 + 0.008));
  const availForHouseMaxDp10 = availForHouseMax10 * 0.1;
  const availForHouseMaxCc10 = 1200 + availForHouseMax10 * (0.017 * 0.5 + 0.9 * 0.0055 * 0.5 + 0.008);

  const availForMaxPayment10 =
    availForHouseMax10 * (perDollarPandI10 + perDollarTaxesAndInsurance + perDollarMortgageInsurance10);

  const mortgagePayment = Math.max((incomeValue * Number(data.dtiLevel)) / Number(12) - totalDebtPayments, 0);

  const houseValue5 = Math.max(
    mortgagePayment / (perDollarPandI5 + perDollarTaxesAndInsurance + perDollarMortgageInsurance5),
    0,
  );

  const houseValue10 = Math.max(
    mortgagePayment / (perDollarPandI10 + perDollarTaxesAndInsurance + perDollarMortgageInsurance10),
    0,
  );

  const houseValue15 = Math.max(
    mortgagePayment / (perDollarPandI15 + perDollarTaxesAndInsurance + perDollarMortgageInsurance15),
    0,
  );

  const houseValue20 = Math.max(
    mortgagePayment / (perDollarPandI20 + perDollarTaxesAndInsurance + perDollarMortgageInsurance20),
    0,
  );

  const houseValueDp5 = houseValue5 * 0.05;
  const houseValueDp10 = houseValue10 * 0.1;
  const houseValueDp15 = houseValue15 * 0.15;
  const houseValueDp20 = houseValue20 * 0.2;

  /* house value times half year taxes and ins PLUS half year MI PLUS Title */

  const houseValueCc5 = 1200 + houseValue5 * (0.017 * 0.5 + 0.95 * 0.0078 * 0.5 + 0.008);
  const houseValueCc10 = 1200 + houseValue10 * (0.017 * 0.5 + 0.9 * 0.0055 * 0.5 + 0.008);
  const houseValueCc15 = 1200 + houseValue15 * (0.017 * 0.5 + 0.85 * 0.0025 * 0.5 + 0.008);
  const houseValueCc20 = 1200 + houseValue20 * (0.017 * 0.5 + 0 + 0.008);
  const houseValueCashToClose5 = houseValueDp5 + houseValueCc5;
  const houseValueCashToClose10 = houseValueDp10 + houseValueCc10;
  const houseValueCashToClose15 = houseValueDp15 + houseValueCc15;
  const houseValueCashToClose20 = houseValueDp20 + houseValueCc20;

  let houseValue;
  let houseValueDp;
  let pni;
  let propTaxes;
  let mortIns;
  let hazIns;
  let houseValueCc;
  let mortgagePaymentFinal = mortgagePayment;

  if (availForHouse > houseValueCashToClose20) {
    houseValue = houseValue20;
    houseValueDp = houseValueDp20;
    pni = perDollarPandI20 * houseValue20;
    propTaxes = (0.013 * houseValue20) / 12;
    mortIns = 0;
    hazIns = (0.004 * houseValue20) / 12;
    houseValueCc = houseValueCc20;
  } else if (availForHouse > houseValueCashToClose15) {
    houseValue = houseValue15;
    houseValueDp = houseValueDp15;
    pni = perDollarPandI15 * houseValue15;
    propTaxes = (0.013 * houseValue15) / 12;
    mortIns = perDollarMortgageInsurance15 * houseValue15;
    hazIns = (0.004 * houseValue15) / 12;
    houseValueCc = houseValueCc15;
  } else if (availForHouse > houseValueCashToClose10) {
    houseValue = houseValue10;
    houseValueDp = houseValueDp10;
    pni = perDollarPandI10 * houseValue10;
    propTaxes = (0.013 * houseValue10) / 12;
    mortIns = perDollarMortgageInsurance10 * houseValue10;
    hazIns = (0.004 * houseValue10) / 12;
    houseValueCc = houseValueCc10;
  } else if (availForHouse > houseValueCashToClose5 && houseValue5 <= 537263) {
    houseValue = houseValue5;
    houseValueDp = houseValueDp5;
    pni = perDollarPandI5 * houseValue5;
    propTaxes = (0.013 * houseValue5) / 12;
    mortIns = perDollarMortgageInsurance5 * houseValue5;
    hazIns = (0.004 * houseValue5) / 12;
    houseValueCc = houseValueCc5;
  } else if (availForHouseMax10 > 537263) {
    houseValue = availForHouseMax10;
    houseValueDp = availForHouseMaxDp10;
    pni = perDollarPandI5 * availForHouseMax10;
    propTaxes = (0.013 * availForHouseMax10) / 12;
    mortIns = perDollarMortgageInsurance10 * availForHouseMax5;
    hazIns = (0.004 * availForHouseMax10) / 12;
    houseValueCc = availForHouseMaxCc10;
    mortgagePaymentFinal = Math.max(availForMaxPayment10, 0);
  } else {
    houseValue = Math.max(availForHouseMax5, 0);
    houseValueDp = Math.max(availForHouseMaxDp5, 0);
    pni = Math.max(perDollarPandI5 * availForHouseMax5, 0);
    propTaxes = (0.013 * availForHouseMax5) / 12;
    mortIns = perDollarMortgageInsurance5 * availForHouseMax5;
    hazIns = (0.004 * availForHouseMax5) / 12;
    houseValueCc = Math.max(availForHouseMaxCc5, 0);
    mortgagePaymentFinal = Math.max(availForMaxPayment5, 0);
  }

  return {
    incomeValue,
    houseValue,
    houseValueDp,
    carPaymentValue,
    studentPaymentValue,
    cardPaymentValue,
    mortgagePaymentFinal,
    pni,
    propTaxes,
    mortIns,
    hazIns,
    monthlyIncome,
    totalDebtPayments,
    otherPaymentValue,
    savingsValue,
    equityValue,
    availForHouse,
    savingsCushion,
    houseValueCc,
    mortgagePayment,
  };
};

export const calculateMonthlyTaxes = (hasSecondPerson, incomeValue) => {
  const deductionB1 = 10000;
  const dedcutionB2 = 20000;
  let deduction;

  if (hasSecondPerson) {
    deduction = dedcutionB2;
  } else {
    deduction = deductionB1;
  }

  const taxableIncome = incomeValue - deduction;
  let annualTaxes;

  if (hasSecondPerson) {
    if (taxableIncome < 19751) {
      annualTaxes = taxableIncome * 0.1;
    } else if (taxableIncome < 80251) {
      annualTaxes = 1975 + (taxableIncome - 19750) * 0.12;
    } else if (taxableIncome < 171051) {
      annualTaxes = 9235 + (taxableIncome - 80250) * 0.22;
    } else if (taxableIncome < 326601) {
      annualTaxes = 29211 + (taxableIncome - 171050) * 0.24;
    } else if (taxableIncome < 414701) {
      annualTaxes = 66543 + (taxableIncome - 326600) * 0.32;
    } else if (taxableIncome < 622051) {
      annualTaxes = 94735 + (taxableIncome - 414700) * 0.35;
    } else {
      annualTaxes = 167308 + (taxableIncome - 622050) * 0.37;
    }
  } else if (taxableIncome < 9876) {
    annualTaxes = taxableIncome * 0.1;
  } else if (taxableIncome < 40126) {
    annualTaxes = 988 + (taxableIncome - 9875) * 0.12;
  } else if (taxableIncome < 85526) {
    annualTaxes = 4618 + (taxableIncome - 40125) * 0.22;
  } else if (taxableIncome < 163301) {
    annualTaxes = 14606 + (taxableIncome - 85525) * 0.24;
  } else if (taxableIncome < 207351) {
    annualTaxes = 33272 + (taxableIncome - 163300) * 0.32;
  } else if (taxableIncome < 518401) {
    annualTaxes = 47368 + (taxableIncome - 207350) * 0.35;
  } else {
    annualTaxes = 156235 + (taxableIncome - 518400) * 0.37;
  }

  const annualStateTaxes = taxableIncome * 0.02;

  let payrollTaxes;
  if (hasSecondPerson) {
    if (incomeValue > 260000) {
      payrollTaxes = 20800;
    } else {
      payrollTaxes = incomeValue * 0.08;
    }
  } else if (incomeValue > 130000) {
    payrollTaxes = 10400;
  } else {
    payrollTaxes = incomeValue * 0.08;
  }

  return (annualTaxes + payrollTaxes + annualStateTaxes) / 12;
};



// WEBPACK FOOTER //
// ./src/utils/quizHelper.js